
<template lang="html">
    <!-- content bar
    ================================================== -->
    <div class="content-bar">
        <div class="row content-bar__filter">
            <div class="col-full">
                <strong>Filter : </strong>
                <button data-popup-trigger="filters-subject" class="content-bar__btn content-bar__btn--filter" title="Subject Filters">
                    <i class="fa fa-briefcase" aria-hidden="true"></i><span>Subject</span>
                </button>
                <button data-popup-trigger="filters-style" class="content-bar__btn content-bar__btn--filter" title="Style or Medium Filters">
                    <i class="fa fa-paint-brush" aria-hidden="true"></i><span>Style/Medium</span>
                </button>
                <button data-popup-trigger="filters-type" class="content-bar__btn content-bar__btn--filter" title="Type Filters">
                    <i class="fa fa-tag" aria-hidden="true"></i><span>Type</span>
                </button>
                <button data-popup-trigger="filters-location" class="content-bar__btn content-bar__btn--filter" title="Location Filters">
                    <i class="fa fa-map" aria-hidden="true"></i><span>Location</span>
                </button>
            </div>
        </div>
    </div>

</template>

<script>
// Components contains button which trigger appearing modal with search filters

import _ from 'lodash';

export default {
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  watch: {
  }
};
</script>
